export default [
    {
        name: 'Pleitos',
        url: '/pleitos/fornecedor',
        icon: 'fa fa-file-text-o',
        regras: 'PLEITOS-FORN-00',
        badge: {
            variant: 'primary',
            text: 'FORNECEDOR'
        }
    }
]